import type { DatabaseDetail, PlatformSnapshot, ServicesDetail, TimeWindow, TimeseriesPayload } from './types';

function token(): string | null {
  return sessionStorage.getItem('portal_token');
}

async function adminGet<T>(path: string, signal?: AbortSignal): Promise<T> {
  const auth = token();
  if (!auth) {
    const err = new Error('UNAUTHENTICATED');
    (err as Error & { code?: string }).code = 'UNAUTHENTICATED';
    throw err;
  }
  const res = await fetch(path, {
    headers: { Authorization: `Bearer ${auth}` },
    signal,
  });
  if (res.status === 401) {
    const err = new Error('UNAUTHENTICATED');
    (err as Error & { code?: string }).code = 'UNAUTHENTICATED';
    throw err;
  }
  const json = await res.json();
  if (!res.ok || !json.success) {
    throw new Error(json.error || 'Request failed');
  }
  return json.data as T;
}

export function fetchSnapshot(windowKey: TimeWindow, signal?: AbortSignal) {
  return adminGet<PlatformSnapshot>(
    `/api/v1/admin/platform-health/snapshot?window=${encodeURIComponent(windowKey)}`,
    signal,
  );
}

export function fetchTimeseries(
  params: { resource: 'database' | 'compute'; metric: string; window: TimeWindow; service?: string },
  signal?: AbortSignal,
) {
  const q = new URLSearchParams({
    resource: params.resource,
    metric: params.metric,
    window: params.window,
  });
  if (params.service) q.set('service', params.service);
  return adminGet<TimeseriesPayload>(`/api/v1/admin/platform-health/timeseries?${q.toString()}`, signal);
}

export function fetchDatabase(windowKey: TimeWindow, signal?: AbortSignal) {
  return adminGet<DatabaseDetail>(
    `/api/v1/admin/platform-health/database?window=${encodeURIComponent(windowKey)}`,
    signal,
  );
}

export function fetchServices(windowKey: TimeWindow, signal?: AbortSignal) {
  return adminGet<ServicesDetail>(
    `/api/v1/admin/platform-health/services?window=${encodeURIComponent(windowKey)}`,
    signal,
  );
}
